<template>
  <div>
    <!-- hero section -->
    <section class="section section-container-hero section-shaped hero my-0">
      <div class="shape"></div>
      <div class="container shape-container d-flex align-items-center">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 text-center col-md-5">
              <h2 class="display-2 text-white mb-5 hero-title">
                ABOUT US
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Easyhomes desc -->
    <section>
      <div class="col px-0">
        <div class="justify-content-center align-items-center">
          <div class="container col-lg-10 col-md-7">
            <p class="text-gray m-4 paraTEXT text-justify">
              EASYHOMES INC. has built a track record for safe and efficient
              construction. Our team of skilled engineers, industrial
              contractors, and civil engineers handles projects that come with
              special requirements in terms of materials and technology. Our
              unique approach to prefabricating allows us to handle complex jobs
              quickly and efficiently while maintaining high quality.
            </p>
            <p class="text-gray m-4 paraTEXT text-justify">
              Incorporated in 2007, we are a precast fence company, with more
              than 200,000 linear-meter fence installations under our belt. Our
              clients range from PPP-funded expressways, high-end residential
              developments, low-end housing projects, industrial plants, and
              warehouses, to other projects that require securing of properties.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!--MILESTONES-->
    <section class="section section-lg sec" style="background-color: #E6E7E9">
      <div class="row">
        <h1 class="title">MILESTONES</h1>
        <hr class="hr-line mb-4" style="width: 60rem;" />
        <div class="fst text-center">
          <img src="/img/about/optimized/3.png" class="col-sm-11 col-md-10 col-lg-9 col-xl-8" alt="Milestones" />
          <img src="/img/about/optimized/4.png" class="col-sm-11 col-md-10 col-lg-9 col-xl-8" alt="Milestones" />
        </div>
      </div>
    </section>

    <!--MESSAGE FROM THE OWNER-->

    <section class="section section-lg sec" style="background-color: ">
      <div class="container-fluid">
        <h2 class="head">Message From The Founder</h2>
        <div class="row">
          <div class="col-sm-12 text-center col-md-4 col-lg-3">
            <img src="/img/about/optimized/owner.png" alt="Image" class="image" />
            <h5 class="text-center name">
              Celso E. Abastillas <br />
              <strong>Chairman/CEO</strong>
            </h5>
          </div>
          <div class="col-sm-12 col-md-8 col-lg-9 mt-sm-4 mt-md-0">
            <p class="text-justify paragraph">
              The Best Years To Come <br />
              <br />
              How blessed we are that we were not affected too much by Covid 19
              pandemic. We deal in pallets that are used in transporting foods
              and other essentials. So instead of scaling or shutting down like
              many in the hospitality businesses, we were on business as usual.
              Our fence business was not much affected too except for projects
              where clients are very strict on health protocols like requiring
              vaccination cards. Or there were clients that limited the number
              of people working in their areas to minimize if not avoid
              contamination. <br />
              <br />
              Our trees and coconut plantations, were not affected either. In
              fact we’re able to increase the number of trees planted and
              harvested as some people displaced in Easyhomes were transferred
              to plantations, thereby increasing its production. <br />
              <br />
              We had already nailed 2 clients for Tawitech, Pakil municipality
              for E-log and PJ Lhullier for Ayun. We currently have 3 or 4 more
              clients in the pipeline, so that will make the staff busy during
              the year.
              <br />
              <br />
              The economy in 2022 is projected to grow 7-7.5% which will make
              the Philippines one among the fastest growing economies in Asia
              and even in the world. The same is true for 2023, when our economy
              will be growing almost the same as in 2022 if not higher...s
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "about-us",
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("/img/about/optimized/aboutus-hero.png");
  background-attachment: fixed;
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.hero-title {
  width: 100%;
  font-size: 3rem;
  margin-top: 50px;
  margin-left: -350px;
  text-shadow: 1px 1px black;
}

.paraTEXT {
  font-weight: 500;
  line-height: 35px;
}

.container {
  max-width: 95.33333%;
}

.sec {
  padding: 3rem 0rem !important;
}

.title {
  color: #000000;
  font-weight: 700;
  font-size: 5rem;
  margin-left: 50px;
}

.hr-line {
  border: 3px solid #fdb210;
  margin: 0 -60px !important;
}

.fst img {
  width: 100%;
  padding: 0 !important;
}

.content {
  display: flex;
  align-items: center;
}

.image {
  width: 100%;
  height: auto;
  margin-left: 45px;
}

.paragraph {
  margin: 0px 55px 0 70px;
  font-size: 17px;
  line-height: 27px;
}

.head {
  color: #4e5152;
  margin-left: 42px;
  font-weight: 600;
}

.name {
  margin-left: 50px;
  margin-top: 2 0px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
    font-size: 2.5rem;
  }

  .name {
    margin-left: 20px;
  }

  .title {
    font-size: 2rem;
  }

  .hr-line {
    width: 20rem !important;
  }

  .image {
    width: 88%;
    margin-left: 24px;
  }

  .paragraph {
    margin: 0px 30px 0 30px;
    font-size: 18px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
    font-size: 4rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hero-title {
    margin-left: -40% !important;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: -50% !important;
  }
}
</style>
